import { createContext, useContext } from 'react';
import { getCurrentPath } from './routing.js';

// The browser and build renderer share a route without inventing a window on
// the server. This context contains a public pathname, never account data.
export const RoutePathContext = createContext(null);
export const useCurrentPath = () => useContext(RoutePathContext) || getCurrentPath();
